import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/studio.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { DesignProvider } from "@/contexts/DesignContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <DesignProvider>
          <App />
        </DesignProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
